// Bubbles Tropics x GAMBGO — Buy 1 Get 1 Free event
// UI-level offer: the cheapest eligible drink's BASE price (no toppings) is free.

export const BUBBLES_TROPICS_ID = '2874e157-906f-4254-ba53-b96d30034b03';
export const BUBBLES_TROPICS_NAME = 'Bubbles - Tropic Shopping Center, Senegambia';
export const BUBBLES_BOGO_CODE = 'BUBBLESBOGO';
export const BUBBLES_BOGO_LIMIT = 50;

// Gambia is GMT+0, so UTC boundaries are the local event day.
const EVENT_START = Date.parse('2026-09-26T00:00:00Z');
const EVENT_END = Date.parse('2026-09-27T00:00:00Z');

export const isBubblesBogoEventLive = (now: Date = new Date()): boolean => {
  const t = now.getTime();
  return t >= EVENT_START && t < EVENT_END;
};

export interface BogoCartItem {
  restaurant_id: string;
  menu_item_id: string;
  price: number;
  quantity: number;
}

/**
 * Discount = base price (without toppings) of the cheapest eligible drink,
 * granted once per order when at least 2 eligible drinks are in the cart.
 * `basePrices` maps menu_item_id -> menu item price without customizations.
 */
export function calculateBubblesBogoDiscount(
  items: BogoCartItem[],
  basePrices: Record<string, number> = {}
): number {
  const units: number[] = [];

  for (const item of items) {
    if (item.restaurant_id !== BUBBLES_TROPICS_ID) continue;
    const base = basePrices[item.menu_item_id] ?? item.price;
    for (let i = 0; i < (item.quantity || 0); i++) units.push(base);
  }

  if (units.length < 2) return 0;
  return Math.min(...units);
}

export function countBubblesBogoUnits(items: BogoCartItem[]): number {
  return items
    .filter((i) => i.restaurant_id === BUBBLES_TROPICS_ID)
    .reduce((sum, i) => sum + (i.quantity || 0), 0);
}
